import { render, staticRenderFns } from "./StorageRoomTable.vue?vue&type=template&id=1bb58b6e&scoped=true"
import script from "./StorageRoomTable.vue?vue&type=script&lang=js"
export * from "./StorageRoomTable.vue?vue&type=script&lang=js"
import style0 from "./StorageRoomTable.vue?vue&type=style&index=0&id=1bb58b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb58b6e",
  null
  
)

export default component.exports